<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
    max-width="70vW"
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Lotes de {{ moSelected ? moSelected.identificationName : "Ag Boost" }}
      </v-card-title>
      <v-card-text>
        <v-container fluid fill-height class="px-0">
          <v-row justify="start" align="start">
            <v-col cols="12" xl="6" lg="6">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                v-model="search"
                label="Buscar..."
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" xl="4" lg="4">
              <v-btn small color="primary" rounded @click="refresh"
                ><v-icon>mdi-refresh</v-icon>
                Refrescar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                height="330px"
                :headers="headers"
                :items="lotes"
                :items-per-page="10"
                no-data-text="No hay lotes"
                loading-text="Cargando lotes..."
                :page.sync="page"
                hide-default-footer
                :loading="fetchingData"
                @click:row="rowSelect"
                :item-class="row_classes"
              >
                <template #[`item.loteId`]="{ item }">
                  <v-row>
                    <v-col
                      v-if="
                        item.alarmValidation1 ||
                        item.alarmInoculate ||
                        item.alarmValidation2 ||
                        item.alarmRice
                      "
                    >
                      <span class="text-caption pa-2 rounded-lg decrease">{{
                        item.loteId
                      }}</span>
                    </v-col>
                    <v-col v-else>
                      <span class="text-caption">{{ item.loteId }}</span>
                    </v-col>
                    <v-col>
                      <v-icon
                        color="primary"
                        v-if="item.lotes && item.lotes.length > 0"
                      >
                        mdi-call-split
                      </v-icon>
                    </v-col>
                  </v-row>
                </template>
                <template #[`item.identificationName`]="{ item }">
                  <span
                    style="font-size: 10px"
                    v-if="
                      item.loteType == 'SINGLE' || item.loteType == 'DIVISON'
                    "
                    >{{ item.identificationName }}</span
                  >

                  <span
                    style="font-size: 10px"
                    v-else-if="item.loteType == 'BIO'"
                    >Ag Boost</span
                  >
                </template>
                <template #[`item.reactivations`]="{ item }">
                  <span
                    class="text-caption"
                    v-if="
                      item.loteType == 'SINGLE' || item.loteType == 'DIVISON'
                    "
                  >
                    <div v-if="item.reactivations">
                      <div
                        v-for="(reac, index) in item.reactivations"
                        :key="index"
                      >
                        <span>
                          {{ reac.serialReactivation }}
                        </span>
                        <v-spacer
                          v-if="index + 1 != item.reactivations.length"
                        ></v-spacer>
                      </div>
                    </div>
                  </span>
                  <span class="text-caption" v-else>-</span>
                </template>
                <template #[`item.lineState`]="{ item }">
                  <span class="text-caption"
                    >{{ item.productLine }}{{ item.lineState }}</span
                  >
                </template>
                <template #[`item.presentation`]="{ item }">
                  <span class="text-caption" v-if="item.presentation">{{
                    item.presentation
                  }}</span>
                  <span class="text-caption">No disponible</span>
                </template>
                <template #[`item.dosesStart`]="{ item }">
                  <span class="text-caption">{{ item.dosesStart }}</span>
                </template>
                <template #[`item.dosesEnd`]="{ item }">
                  <span class="text-caption">{{ item.dosesEnd }}</span>
                </template>
                <template #[`item.reactivationDate`]="{ item }">
                  <span style="font-size: 10px">{{
                    dateFormatShort(item.reactivationDate)
                  }}</span>
                </template>
                <template #[`item.spore_date`]="{ item }">
                  <span style="font-size: 10px">{{
                    dateFormatShort(item.spore_date)
                  }}</span>
                </template>
                <template #[`item.possibleDosage`]="{ item }">
                  <span style="font-size: 10px" v-if="item.possibleDosage">{{
                    item.possibleDosage
                  }}</span>
                  <span style="font-size: 10px" v-else>{{ item.stock }}</span>
                </template>
                <template #[`item.productionState`]="{ item }">
                  <div v-if="item.productionState == 'SIFTING'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Molido/Tamizado
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'DRYING'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Secado
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'INCUBATING'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Incubación
                    </span>
                  </div>
                  <div v-else-if="item.productionState == '1_VALIDATION'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      1ra validación
                    </span>
                  </div>
                  <div v-else-if="item.productionState == '2_VALIDATION'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      2da validación
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'STOCK'">
                    <span class="text-caption pa-2 rounded-lg stockSpore">
                      Stock de espora
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'STOCK_PT'">
                    <span class="text-caption pa-2 rounded-lg stockSpore">
                      Almacen PT
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'PREINOCULATE'">
                    <span class="text-caption pa-2 rounded-lg finish">
                      Preinóculo
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'CONTAMINATED'">
                    <span class="text-caption pa-2 rounded-lg decrease">
                      Contaminado
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'USELESS'">
                    <span class="text-caption pa-2 rounded-lg decrease">
                      Lote desechado
                    </span>
                  </div>
                  <div v-else-if="item.productionState == 'INOCULATE'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      inóculo
                    </span>
                  </div>

                  <div v-if="item.productionState == 'GRINDING'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Molienda
                    </span>
                  </div>
                  <div v-if="item.productionState == 'FERMENTATION'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Fermentación
                    </span>
                  </div>
                  <div v-if="item.productionState == 'DIGESTION'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Digestión
                    </span>
                  </div>
                  <div v-if="item.productionState == 'FORMULATION'">
                    <span class="text-caption pa-2 rounded-lg finish">
                      Formulación/Envasado
                    </span>
                  </div>
                  <div v-if="item.productionState == 'SEED'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Semilla
                    </span>
                  </div>
                  <div v-if="item.productionState == 'FEEDABLE'">
                    <span class="text-caption pa-2 rounded-lg comonstate">
                      Realimentación
                    </span>
                  </div>
                </template>
              </v-data-table>
              <v-pagination
                v-model="page"
                :length="numPages"
                total-visible="10"
                color="primary"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="red" block @click="closeModal()" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
// date library
import dayjs from "dayjs";
//components

export default {
  data: () => ({
    search: null,
    headers: [
      { text: "Lote", align: "start", value: "loteId", sortable: false },
      { text: "Microorganismo", value: "identificationName", sortable: false },
      {
        text: "Reactivación",
        align: "center",
        value: "reactivation",
        sortable: false,
      },
      { text: "Linea", align: "center", value: "lineState", sortable: false },

      {
        text: "Dosis incial",
        align: "center",
        value: "dosesStart",
        sortable: false,
      },
      {
        text: "Dosis final",
        align: "center",
        value: "dosesEnd",
        sortable: false,
      },
      {
        text: "Fecha reactivación",
        align: "center",
        value: "reactivationDate",
        sortable: false,
      },
      {
        text: "Stock",
        align: "center",
        value: "possibleDosage",
        sortable: false,
      },
      {
        text: "Etapa",
        align: "center",
        value: "productionState",
        sortable: false,
      },
    ],
    lotes: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
    showNewReactivation: false,
    showNewLote: false,
    showFiltersLotesModal: false,
    showStockModal: false,
    showSupplyModal: false,
    filters: null,
    expanded: [],
  }),

  async created() {
    // this.search = this.moSelected.identificationName;
    if (this.moSelected) {
      if (
        this.moSelected.moType == "fungi" ||
        this.moSelected.identificationName == "Streptomyces griseoviridis"
      ) {
        this.filters = {
          mo: this.moSelected,
          line: null,
          productionState: "STOCK",
        };
      } else if (this.moSelected.moType == "bacteria") {
        this.filters = {
          mo: this.moSelected,
          line: null,
          productionState: "STOCK_PT",
        };
      }
    } else {
      this.filters = {
        isBio: true,
        mo: null,
        line: null,
        productionState: "STOCK_PT",
      };
    }

    await this.fetchData();
  },
  methods: {
    ...mapActions("lotes", ["getLotesStock"]),
    ...mapMutations("lotes", ["SET_MO_SELECTED"]),
    closeModal() {
      this.SET_MO_SELECTED(null);
      this.show = false;
    },
    async requestStrain() {
      this.$router.push(`/cepario-production`);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    rowSelect(rowValue) {
      this.lotes = this.lotes.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async refresh() {
      await this.fetchData();
    },
    async fetchData() {
      try {
        this.fetchingData = true;

        let response = await this.getLotesStock({
          page: this.page,
          search: this.search,
          filters: this.filters,
        });
        if (response) {
          if (!response.error) {
            if (response.lotes.length > 0) {
              if (!this.loteSelected) {
                for (let item of response.lotes) {
                  item.clicked = false;
                }
              } else {
                for (let item of response.lotes) {
                  if (this.loteSelected._id == item._id) {
                    item.clicked = true;
                  } else {
                    item.clicked = false;
                  }
                }
              }
            }
            console.log(response.lotes);
            this.lotes = response.lotes;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar lotes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar lotes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar lotes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    async filtering(value) {
      this.filters = {
        mo: null,
        line: null,
        productionState: "STOCK",
      };
      await this.fetchData();
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      await this.fetchData();
    },

    async fetchLotesList(value) {
      if (value) {
        await this.fetchData();
      }
    },
  },
  computed: {
    ...mapState("lotes", ["fetchLotesList", "loteSelected", "moSelected"]),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: {
    value: Boolean,
  },
};
</script>

<style scoped>
.finish {
  background-color: #04c105;
  color: white;
}
.comonstate {
  background-color: #dadada;
  color: black;
}
.decrease {
  background-color: red;
  color: white;
}
.stockSpore {
  background-color: #fbc02d;
  color: white;
}
</style>
